export default __webpack_public_path__ + "static/media/help-3.958c1528.png";